import styled from 'styled-components';
import { TitleMedium500, TitleLarge500, BodyMedium500, BodyMedium400, TitleXSmall500 } from '@nebula/global-styles';
import { TextLinkBack } from '@nebula/text-link';
import Button from '@nebula/button';
import { InformationAlert } from '@nebula/alert';

const ChooseNewBillingDateWrapper = styled.div(
  ({ theme }) => `
    @media ${theme.media.tabletPortraitMin} {
      display: flex;
      justify-content: center;
      background: ${theme.color.ui.grey[10]};
    }
`
);

const ChooseNewBillingDateContainer = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 8px;

  @media (min-width: 375px) { // min: 375px
    width: 100%;
    padding: 0px 16px;
  }

  @media ${theme.media.tabletPortraitMin} { // min: 768px
    width: 100%;
    padding: 0px 24px;
  }

  @media ${theme.media.tabletLandscapeMin} { //min: 1024px
    padding: 0px;
    max-width: 802px;
  }
`
);

const ChooseNewBillingDateTextLinkBack = styled(TextLinkBack)(
  ({ theme }) => `
  padding: 16px 8px 0px 8px;

  @media (min-width: 375px) {
    padding: 16px 0px 0px 0px;
  }

  @media ${theme.media.tabletPortraitMin} {
    padding-top: 24px;
  }

  @media ${theme.media.tabletLandscapeMin} {
    padding-top: 32px;
    margin-bottom: 8px;
  }
`
);

const StepIndicatorContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px 0px 16px 8px;
  height: 52px;
  width: 178px;
  align-items: center;
  text-wrap-mode: nowrap;
  column-gap: 10px;

  @media (min-width: 375px) {
    padding: 16px 0px 16px 0px;
  }
`;
const ChooseNewBillingDateTitleContainer = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
  padding-left: 8px;
  row-gap: 2px;

  @media (min-width: 375px) {
    padding-bottom: 16px;
    padding-left: 0px;
  }

  @media ${theme.media.tabletLandscapeMin} {
    row-gap: 4px;
    padding-bottom: 24px;
  }
`
);

const ChooseNewBillingDateTitleMedium500 = styled(TitleMedium500)`
  margin-bottom: 0px;
  margin-top: 0px;
  font-size: 24px;
  line-height: 36px;
`;

const ChooseNewBillingDateTitleLarge500 = styled(TitleLarge500)`
  margin-bottom: 0px;
  margin-top: 0px;
  font-size: 28px;
  line-height: 40px;
`;
const DateNotSelectedErrorPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
`;

const DateNotSelectedErrorMessage = styled(BodyMedium500)(
  ({ theme }) => `
  color: ${theme.color.messaging.red[70]};
  margin: 0;
   @media ${theme.media.tabletLandscapeMin} {
   font-size: 16px;
  }
`
);

const ChooseNewBillingDateFooter = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px 8px;

  @media (min-width: 375px) {
    padding: 16px 0px;
  }

  @media ${theme.media.tabletLandscapeMin} {
    row-gap: 32px;
    padding: 32px 0px;
  }
`
);

const InformationAlertContainer = styled.div`
  > div {
    width: 100%;
    ${TitleXSmall500} {
      font-size: 14px;
    }
    ${BodyMedium400} {
      font-size: 14px;
    }
    @media ${({ theme }) => theme.media.tabletLandscapeMin} {
      min-width: 596px;
      max-width: fit-content;
      ${TitleXSmall500} {
        font-size: 16px;
      }
      ${BodyMedium400} {
        font-size: 16px;
      }
    }
  }
`;

const ChooseNewBillingDateInformationAlert = styled(InformationAlert)(`
  width: fit-content !important;
  padding: 0 !important;
`);

const CancelAndContinueContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex-direction: row-reverse;
    justify-content: flex-end;
    column-gap: 24px;
  }
`;

const ContinueOrCancelButton = styled(Button)`
  width: 100%;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: fit-content;
  }

  ${({ buttonKind, isWebview, theme }) =>
    buttonKind === 'primaryMagenta' &&
    isWebview &&
    `
     background-color: ${theme.color.decorative.magenta[70]} !important;
     border-color: ${theme.color.decorative.magenta[70]} !important;
    `}

  ${({ buttonKind, isWebview, theme }) =>
    buttonKind === 'secondaryMagenta' &&
    isWebview &&
    `
    color: ${theme.color.decorative.magenta[70]} !important;
    border-color: ${theme.color.decorative.magenta[70]} !important;
    `}
`;

export const AriaHideContainer = styled.div.attrs(() => ({
  'aria-hidden': 'true',
}))`
  display: contents;
`;

export {
  ChooseNewBillingDateWrapper,
  ChooseNewBillingDateContainer,
  StepIndicatorContainer,
  ChooseNewBillingDateTitleMedium500,
  ChooseNewBillingDateTitleLarge500,
  ChooseNewBillingDateTextLinkBack,
  ChooseNewBillingDateTitleContainer,
  DateNotSelectedErrorPlaceholder,
  DateNotSelectedErrorMessage,
  ContinueOrCancelButton,
  InformationAlertContainer,
  ChooseNewBillingDateInformationAlert,
  CancelAndContinueContainer,
  ChooseNewBillingDateFooter,
};
